export const firebaseConfig = {
    apiKey: ENV.APP_FIREBASE_CONFIG_APIKEY,
    authDomain: ENV.APP_FIREBASE_CONFIG_AUTHDOMAIN,
    projectId: ENV.APP_FIREBASE_CONFIG_PROJECTID,
    storageBucket: ENV.APP_FIREBASE_CONFIG_STORAGEBUCKET,
    messagingSenderId: ENV.APP_FIREBASE_CONFIG_MESSAGINGSENDERID,
    appId: ENV.APP_FIREBASE_CONFIG_APPID,
    measurementId: ENV.APP_FIREBASE_CONFIG_MEASUREMENTID
};
export const vapidKey = ENV.APP_FIREBASE_VAPID_KEY;
